module.exports = __webpack_public_path__ + "img/icon-white-47.9ea865cf.svg";